import { NAME } from './constants';

export const FETCH_CONTACT = `${NAME}/FETCH_CONTACT`;
export const FETCH_CONTACT_FAILURE = `${NAME}/FETCH_CONTACT_FAILURE`;
export const FETCH_CONTACT_SUCCESS = `${NAME}/FETCH_CONTACT_SUCCESS`;

export const SELECT_TAB = `${NAME}/SELECT_TAB`;
